import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'tanok';
import { t } from 'c-3po';

import { toJS } from '../../../helpers/ImmutableToJS';

import * as c from './../../../../libs/constants';

import { Button } from '../../../ui/button';
import { Tabs } from '../../../ui/tabs';

// styles
import css from './authBody.sss';

// TODO get app urls to conf (packages/chat-prom-mobile/public/devkit/config/index.js:9)
// appUrl = '...'

class StartView extends React.Component {
    state = {
        role: 'buyer'
    }

    handleChangeRole = (role) => {
        this.setState({
            role
        });
    }

    render() {
        const { changeAuthTab } = this.props;
        let titleText;
        let buttonText;
        let appText;
        let appUrl = '';

        switch (this.state.role) {
            case 'company':
                titleText = t`Присоединяйтесь к тысячам продавцов`;
                buttonText = t`Войти как продавец`;
                appText = t`Управляйте своим интернет-магазином в любое удобное время!`;
                appUrl = '';
                break;
            case 'buyer':
                titleText = t`Присоединяйтесь к миллионам покупателей`;
                buttonText = t`Войти как покупатель`;
                appText = t`Управляйте своими заказами в любое удобное время!`;
                appUrl = '';
                break;
            default:
                titleText = t`Присоединяйтесь к миллионам покупателей`;
                buttonText = t`Войти`;
                appText = t`Управляйте своими заказами в любое удобное время!`;
                appUrl = '';
        }

        return (
            <div className={css.root} data-qaid='registration_block'>
                <div className={css.roleSwitcher}>
                    {/* JUST for design */}
                    <Tabs>
                        <Tabs.Item
                            active={this.state.role === 'buyer'}
                            onItemClick={() => this.handleChangeRole('buyer')}
                        >
                            {t`Покупатель`}
                        </Tabs.Item>
                        <Tabs.Item
                            active={this.state.role === 'company'}
                            onItemClick={() => this.handleChangeRole('company')}
                        >
                            {t`Продавец`}
                        </Tabs.Item>
                    </Tabs>
                </div>
                <div className={css.container}>
                    <div className={css.content}>
                        <div className={css.title}>
                            {titleText}
                        </div>
                        <Button
                            dataQa='auth_profile_link'
                            onClick={changeAuthTab(c.CHAT_AUTH_LOGIN, c.ANALCS_ACTION_AUTHORIZATION)}
                        >
                            {buttonText}
                        </Button>
                        <div className={css.additionalControls}>
                            {t`Нет профиля? `}
                            <span
                                className={css.link}
                                data-qaid='registration_btn'
                                onClick={changeAuthTab(c.CHAT_AUTH_REGISTER, c.ANALCS_ACTION_REGISTER_START)}
                            >
                                <b>{t`Зарегистрироваться`}</b>
                            </span>
                        </div>
                    </div>
                </div>
                {appUrl && (
                    <div className={css.app}>
                        <div className={css.appText}>
                            {appText}
                        </div>
                        <a href={appUrl} className={css.appLink}>
                            <span className={css.appIcon} />
                            <b>{t`Скачать приложение`}</b>
                        </a>
                    </div>
                )}
            </div>
        );
    }
}

StartView.propTypes = {
    changeAuthTab: PropTypes.func,
};

const mapStateToProps = (state) => ({
    locale: state.get('locale'),
});

export const Start = connect(mapStateToProps)(toJS(StartView));
